import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ListTodo } from "lucide-react";
import UserTaskInfo from "./UserTaskInfo";
import "./ViewUserTask.css";

const ViewUserTask = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const taskData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="utv-header-banner">
        <button
          type="button"
          className="utv-back-btn"
          onClick={() => navigate(-1)}
          aria-label="Back"
        >
          <ArrowLeft size={16} />
        </button>
        <span className="utv-header-icon">
          <ListTodo size={14} color="#fff" />
        </span>
        <div>
          <div className="utv-header-title">View Daily Task</div>
          <div className="utv-header-subtitle">Task details and assignment</div>
        </div>
      </div>
      <UserTaskInfo taskData={taskData} />
    </div>
  );
};

export default ViewUserTask;
